import { environment } from "src/environments/environment";

export enum ssoConfig {
    tokenExpiresInMin = 2,
    timeBeforeCallingRefreshInSecs = environment.timeBeforeCallingRefreshInSecs
}